import { render, staticRenderFns } from "./statTransfMonth.vue?vue&type=template&id=60d68ef0&scoped=true&"
import script from "./statTransfMonth.vue?vue&type=script&lang=js&"
export * from "./statTransfMonth.vue?vue&type=script&lang=js&"
import style0 from "./statTransfMonth.vue?vue&type=style&index=0&id=60d68ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d68ef0",
  null
  
)

export default component.exports